'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgFileGuide = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12 4.07 2 2.31v2.03l9 1.59V19.4l-7-1.23V6.72l-2-.35v13.47l10 1.76 10-1.76V2.31L12 4.07Zm8 14.09-7 1.23V5.93l7-1.23v13.46Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m18.5 8.65-4 .7v2.03l4-.7V8.65ZM18.5 12.71l-4 .7v2.03l4-.7v-2.03Z" })
);

module.exports = SvgFileGuide;
//# sourceMappingURL=FileGuide.cjs.js.map
